import { Route } from '@angular/router';
import {
  applyTenantUrlGuard,
  authRoutes,
  hasScopesGuard,
  tenantAuthGuard,
} from '@mds/ngx-auth';
import { deploymentRoutes } from './components/deployment/deployment.routes';
import { driverRoutes } from './components/driver/driver.routes';
import { driverPlanningRoutes } from './components/driver-planning/driver-planning.routes';
import { shiftRoutes } from './components/shift/shift.routes';
import { vehicleRoutes } from './components/vehicle/vehicle.routes';
import { vehiclePlanningRoutes } from './components/vehicle-planning/vehicle-planning.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: 'error/:code',
        loadComponent: () =>
          import('@mds/ngx-layout').then((m) => m.ErrorPageComponent),
      },
      authRoutes,
      {
        path: '',
        canActivate: [tenantAuthGuard],
        canMatch: [applyTenantUrlGuard],
        children: [
          {
            path: ':tenantId',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./components/home/home.component').then(
                    (m) => m.HomeComponent,
                  ),
              },
              {
                path: 'shifts',
                children: shiftRoutes,
                canActivate: [hasScopesGuard(['shifts:read'])],
              },
              {
                path: 'vehicles',
                children: vehicleRoutes,
                canActivate: [hasScopesGuard(['vehicles:read'])],
              },
              {
                path: 'vehicleplanning',
                children: vehiclePlanningRoutes,
                canActivate: [hasScopesGuard(['deployments:read'])],
              },
              {
                path: 'drivers',
                children: driverRoutes,
                canActivate: [hasScopesGuard(['drivers:read'])],
              },
              {
                path: 'driverplanning',
                children: driverPlanningRoutes,
                canActivate: [hasScopesGuard(['deployments:read'])],
              },
              {
                path: 'deployments',
                children: deploymentRoutes,
                canActivate: [hasScopesGuard(['deployments:read'])],
              },
            ],
          },
        ],
      },
      {
        path: '**',
        redirectTo: '/error/404',
      },
    ],
  },
];
